import React from "react"
import CheckBox from "components/checkbox"

const PdfSection = ({ coursewareDetails, config, onMarkComplete }) => {
  let url = ""
  if (coursewareDetails.type === "link") {
    url = coursewareDetails.url
  } else {
    let pdfUrl = config?.pdf_download
      ? coursewareDetails.file
      : `${coursewareDetails.file}#toolbar=0`
    url = pdfUrl
  }

  const showZoomInstruction =
    coursewareDetails.type !== "link" && !config?.pdf_download

  return (
    <>
      <div className="checkbox-container">
        <CheckBox
          text="Mark as Complete"
          value={coursewareDetails.completed}
          checked={coursewareDetails.completed}
          id={`chk-complete-${coursewareDetails.id}`}
          tooltip="You are required to Mark this as Completed to complete your progress"
          onClick={() => (onMarkComplete ? onMarkComplete() : false)}
        />
        <p>
          You are required to Mark this as Completed to complete your progress
        </p>
      </div>
      <div className="courseware-details">
        <h2 className="courseware-title">{`${coursewareDetails.name}`}</h2>
        {coursewareDetails.description && (
          <p className="courseware-description">
            {coursewareDetails.description}
          </p>
        )}
      </div>
      <div className="pdf-container">
        <iframe title={coursewareDetails.name} src={url} />
        {showZoomInstruction && (
          <p className="instruction-text">
            Zoom: Scroll up or down while holding Ctrl or CMD button.
          </p>
        )}
      </div>
    </>
  )
}

export default PdfSection
